export default __webpack_public_path__ + "static/media/live-stream-logo.a62c71eb.svg";